/**
 * What kind of flow this JSON is. The compiler emits `data_api_version` exactly when some step
 * exchanges data mid-flow (a booking flow's live times, or a step that calls the owner's server),
 * so the JSON itself says whether it is dynamic.
 */
export const inferFlowType = (flowJson) => (flowJson?.data_api_version ? 'DYNAMIC' : 'STATIC');

/** The flow's saved type when it has one, otherwise what its JSON says. */
export const flowTypeOf = (flow, flowJson) => flow?.flowType || inferFlowType(flowJson ?? flow?.flowJson);
